"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sersale": {
    "36b537e7": [{
      "hkey": "75af409d",
      "slug": "sersale",
      "name": "Sersale",
      "primary": true,
      "skipSearch": false
    }],
    "borda": [{
      "hkey": "75af409d",
      "slug": "sersale",
      "name": "Sersale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e50f3982": [{
      "hkey": "75af409d",
      "slug": "sersale",
      "name": "Sersale",
      "primary": true,
      "skipSearch": false
    }],
    "trebisina": [{
      "hkey": "75af409d",
      "slug": "sersale",
      "name": "Sersale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;